import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { filter } from 'rxjs/operators';

import { SportThemeService } from './core/services/sport-theme.service';
import { TenantThemeService } from './core/tenant/tenant-theme.service';
import { AppLayoutComponent } from './shared/components/app-layout/app-layout.component';
import { ToastHostComponent } from './shared/components/toast-host/toast-host.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AppLayoutComponent, ToastHostComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly tenantTheme = inject(TenantThemeService);
  private readonly sportTheme = inject(SportThemeService);

  private readonly hideShell = signal(true);
  readonly showShell = computed(() => !this.hideShell());

  constructor() {
    this.tenantTheme.init();
    this.sportTheme.init();
    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => {
        let r = this.route.snapshot;
        while (r.firstChild) r = r.firstChild;
        this.hideShell.set(r.data['hideShell'] === true);
      });
  }
}
